import getIframeCSSText from "./get-iframe-css-text";
import notifyResize from "./notify-resize";

/**
 * Handler for window resize event
 * If experience is maximized, only notify of window dimensions -
 * changing iframe positioning will minimize the experience
 *
 * @param {HTMLIFrameElement} iframe
 * @param {HTMLElement} convo
 * @returns {void}
 */
export default function resizeIframe(iframe, convo) {
  if (document.documentElement.dataset.convo === "maximized") {
    notifyResize(iframe);
    return;
  }

  setTimeout(function setIframePosition() {
    if (!convo.hasAttribute("data-maximized")) {
      iframe.style.cssText = getIframeCSSText(convo);
    }
    notifyResize(iframe);
  }, 0);
}
